import type { UniversalIssue } from '@deque/axe-devtools-issues-utils';

export const axeDevtoolsIssueIdExtractor = (issue: UniversalIssue) =>
  issue.issueId || '';

export const axeDedupedIssueIdExtractor = (issue: UniversalIssue) => {
  return [
    issue.pageStateKey,
    issue.ruleId,
    JSON.stringify(issue.selector)
  ].join('_');
};
